<template>
  <div class="iddstation">
    <div class="mobile">
      <div class="left">
        <div class="mobile_img"></div>
        <div>
          <div class="shopname">{{userName}}</div>
          <div>Your personal retail mall</div>
          <div>Product Qty：{{overDataList.length}}</div>
        </div>
      </div>
      <div class="right" @click="tokefu">
        <i class="iconfont icon-kehufuwu"></i>
        Chat
      </div>
    </div>
    <div :class="{'product':true,'fiexed':titleDesc}">
      All Products
    </div>
    
    <div class="header_top">
      <!-- 二级菜单栏 -->
      <div class="query-list-tcp">
        <div class="oknv">
          <div class="logo"></div>
          <div>{{$t('other.a374')}}</div>
        </div>
        <div style="width:800px;position:relative">
          <el-input
            style="width: 320px;"
            clearable
            :placeholder="$t('distribution.searchStore')"
            v-model="dataParams.name"
          ></el-input>
          <el-button class="btn" type="primary" icon="el-icon-search" @click="getStoreItemAndGroup()">{{
            $t("userStoreItems").search
          }}</el-button>
        </div>
        
        <div style="position:relative" @click="goto()">
          <i class="iconfont icon-gouwuche"></i>
          <span class="gowuche">{{$t('other.a375')}}</span>
          <span class="cirlce">{{targetList.length}}</span>
        </div>
      </div>
    </div>


     <!-- <div class="query_list">
        <div :class="{'poo':true,'poo_active': descActive == 'All'}"><span class="test"  @click="chooseCountry('All')">现货货源 所在地区</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'TH'}"> <img style="width:20%" src="../../../assets/img/shopee-thailand.png" /> <span class="test" @click="chooseCountry('TH')">{{$t('h5.DSX_index_th')}}</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'MY'}"> <img style="width:20%" src="../../../assets/img/shopee-malaysia.png" /> <span class="test" @click="chooseCountry('MY')">{{$t('h5.DSX_index_my')}}</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'PH'}"> <img style="width:20%" src="../../../assets/img/shopee-philippines.png" /> <span class="test" @click="chooseCountry('PH')">{{$t('h5.DSX_index_ph')}}</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'TW'}"> <img style="width:20%" src="../../../assets/img/shopee-taiwan.png" /> <span class="test" @click="chooseCountry('TW')">{{$t('h5.DSX_index_tw')}}</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'ID'}"> <img style="width:20%" src="../../../assets/img/shopee-indonesia.png" /> <span class="test" @click="chooseCountry('ID')">{{$t('h5.DSX_index_id')}}</span></div>
        <div :class="{'poo':true,'poo_active': descActive == 'VN'}"> <img style="width:20%" src="../../../assets/img/shopee-vietnam.png" /> <span class="test" @click="chooseCountry('VN')">{{$t('h5.DSX_index_vn')}}</span></div>
      </div> -->
<!-- 
    <div  class="overseaProduct_list">
          <div :class="{'overseaProduct_item':true,'overseaProduct_item_active':activeIndex === index} " @mouseenter="activeIndex=index" @mouseleave="activeIndex=-1"  v-for="(item,index) in overDataList" :key="index" >
              <div style="margin:5px ">
    
              </div>
              <div class="pic_box" @click="viewItem(item)">
                  <img style="width:100%" :src="item.image" />
              </div>
              <div class="title_overseaProduct">{{item.groupName}}</div>
              <div class="item_desc_parentsku">{{$t('distribution.mSKU')}}:{{item.itemSku}}</div>
              <div class="item_desc_parentsku">{{$t('other.a3112')}}:{{item.minGrossProfitRate}}%~{{item.maxGrossProfitRate}}%</div>
              <div  class="item_desc" v-if="item.minPrice !== item.maxPrice && item.minPrice !== 0">{{$t('distribution.oneOffer')}}:￥{{item.minPrice}} ~ {{item.maxPrice}}</div>
              <div  class="item_desc" v-if="item.minPrice == 0 || item.minPrice === item.maxPrice">{{$t('distribution.oneOffer')}}:￥{{item.maxPrice}}</div>
              <div  class="item_desc" >{{$t('distribution.stockNum')}}：{{item.amount >= 0 ? item.amount : 0}}</div>
             
          </div>
      </div> -->
   
    <!-- 产品展示列表 -->
    <div  class="overseaProduct_list">
          <div :class="{'overseaProduct_item':true,'overseaProduct_item_active':activeIndex === index} " @click="viewItem(item)" @mouseenter="activeIndex=index" @mouseleave="activeIndex=-1"  v-for="(item,index) in overDataList" :key="index" >
              <div style="margin:5px ">
     
              </div>
              <div class="pic_box" >
                  <img style="width:100%" :src="item.mainImage"  />
              </div>
              <div class="title_overseaProduct">{{item.name}}</div>
              <div  class="item_desc">price：{{item.price}}</div>
              <div  class="item_desc">stock：{{item.stock}}</div>
             
              <div class="update_overseaProduct">
                <span :class="{'btn':true,'btn_reverse':item.checked}" @click="copyStoreItem(item)">{{!item.checked ?  $t('other.a3221') : $t('other.a146')}}</span>
              </div>
          </div>
      </div>
      <!-- <div class="service-body" @click="openmessage">
			<div><img src="../../../assets/img/zixun.png" alt="" style="width:40px;height:40px"></div>
			<div>在线咨询</div>
			

		</div> -->
		<div class="service-mess" v-show="servie">
			<div class="ser-one">
				<div class="ser-one-title">
					<div class="ser-tit-one"><img src="../../../assets/img/h5_login.png" alt="" style="width:50px;height:50px;"></div>
					<div style="margin-left:10px;color:#fff;">{{$t('other.a406')}}{{$t('other.a3222')}}</div>
				</div>
				<div class="ser-one-boy" @click="servie =  !servie">
					<img src="../../../assets/img/jian.png" alt="" style="width:30px;">
				</div>
				
			</div>
			<div class="talk-list">
          <div id="dialogue_box" class="customer_chat_recode">
             <ul>
                 <li :class="{'chat_recode_items':true,'reverse_row':item.fromUserId == userId}" v-for="(item,index) in chatingList" :key="index">
                     <!-- <div class="pic_box">
						<img src="../../../assets/img/boy.png"/>
					</div> -->
					<div  v-if="item.messageType=='image'" :class="{'chat_desc_pic':item.fromUserId != userId,'reverse_desc_row_pic':item.fromUserId == userId}" @click="knowmessage(item)">
							 <el-image
									style="width: 100px; height: 100px"
									:src="item.content"
									:preview-src-list="srcList"
									fit="fit"></el-image>
					</div>
                     <div v-else :class="{'chat_desc':item.fromUserId != userId,'reverse_desc_row':item.fromUserId == userId}" >{{item.content}}</div>
                     <div v-show="item.fromUserId == userId" class="isRead">{{item.isRead ? $t('other.a365') : $t('other.a367')}}</div>
                 </li>
             </ul>
         </div>
			</div>
			<div class="ser-three">
         <div class="ser-th-one">
           <el-upload
                    class="upload-demo"
                    ref="upload"
                    action="/"
                    :http-request="uploadFile_"
                    :auto-upload="true"
                    :show-file-list="false"
                    
                  >
                  <i
                      class="iconfont icon-xiangce"
                      style="font-size: 20px"
                    />
                  </el-upload>
         </div>
        <div class="ser-th-two">
          <div>
             <el-input
            
            type="textarea"
            :rows="5"
            style="border: 0;
            resize: none;width:450px"
                    :placeholder="$t('other.a3223')"
                    v-model="textarea">
        </el-input>
          </div>
         <div class="sendcc">
            <el-button type="primary" size="small" :disabled="textarea == ''">{{$t('other.a369')}}</el-button>
         </div>
        </div>
      </div>
			
		</div>
    <el-dialog :title="$t('chat.hint')" :visible.sync="dialogVisible" width="30%">
      <el-row class="center">
        <ul>
          <li>
            <el-image :src="sendImgUrl" fit="contain"></el-image>
          </li>
        </ul>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendImg(false)">{{$t('chat.cancel')}}</el-button>
        <el-button type="primary" @click="sendImg(true)">{{$t('chat.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TableDialog from "./../components/table.vue";
import userStoreItems from "../../../api/moudles/userStoreItems";
import newOrders from '../../../api/moudles/newOrders'
import QrcodeDialog from '../../../components/dialog/qrcodeDialog'
import utils from '../../../utils/utils'
import MultiSelection from '../../../components/multiSelection'
import { mapState, mapActions, mapMutations } from "vuex";
import config from "../config/config";
import api from '../../../api/api';
import jsonp from '../../../api/jsonp';
import axios from "axios";
export default {
  data() {
    return {
      dialogVisible:false,
      sendImgUrl:'',
      chatingList:[
      ],
      textarea:'',
      servie:false,
      openDialog: false,
      userName:'Dianxiaosheng mall',
      selectedOptions2:['',],
      warehouseId: null,
      descActive:'All',
      warehouseOption: [],
      TitleDesc: "",
      handleParam: null,
      cusCode: "",
      newUserstoreItem: [],
      titleDesc:false,
      offset: 15,
      activeIndex:-1,
      instockdia:false,
      getDataList: null,
      page: 0,
      checkedAll: false,
      isExtened: false,
      isEdit: -1,
      dialogTableVisibleTwo: false,
      additionParents: [],
      allCateGoryList:[],
      isShow: false,
      isAlliance:false,
      isEditGoods: false,
      multipleSelection: [],
      additionItem: null,
      listErrorOptions: [],
      dialogVisible:false,
      mainImg:{
      image:null,
      url:null,
      name:null
    },
    isPc:true,
    conturyCode:'th',
    itemsCount:0,
    tableList: [],
    tableCount: 0,
    count:0,
    currentPage4: 1,
    currentPage:1,
    page: 0,
    value: null,
    dataParams:{
      
      country:null,
      name:null,
      offset:100,
      page:0,
      userId:null
    },
    cageGoryList:[],
    shwoCategory:false,
    overDataList:[],
    name:'',
    cateGoryListCopy:[{
        value: 'zhinan',
        label: this.$t('other.a3198'),
        children:[{
          value:'hebvk',
          label:147
        }]
        }
      ]
     
    }
  },
  components:{
			MultiSelection
	}, 
  computed: {
    // ...mapState({
    //   userId: (state) => state.shopaccess.userInfo.userId,
    // }),

    cusCodeValue(){
      return JSON.parse(JSON.stringify(this.dataParams.name))
    },
    targetList(){
      let list=[]
      this.overDataList.forEach(item => {
        if(item.checked){
          list.push(item) 
        }
      })
      return list
    }

  },
  props:['storeList','storeId'],

  watch: {
        storeList: function (val) {       
            console.log('112541',val);   
        },
        cusCodeValue(){
          if(!this.cusCodeValue){
            this.getCommunityData(this.dataParams)
          }
        },
    },

  created() {
    this.userId=this.$route.query.userId
    this.isPc=utils.judgePcOrAndirod()
    this.init()
    // this.getCategoryByDistribute()
   
    
  },
  mounted() {
     window.addEventListener('scroll', this.getScroll)
},
  methods: {
    ...config,
    ...mapActions("userStoreItems", [
      "updateGroup",
      "sellerUpdateStoreItemDetail",
      'getInstockoperaterecore',
      'deleStoreItems'
    ]),

    ...mapActions("common", [
      "storerageData",
    ]),
    tokefu(){
      this.$router.push({name:'servicechat',query: {userId:this.userId}})
      // this.$router.push('/servicechat');
    },
    // 函数中的参数为 要获取的cookie键的名称。
    getCookie(c_name){
        if (document.cookie.length>0){
            c_start=document.cookie.indexOf(c_name + "=");
            if (c_start!=-1){
                c_start=c_start + c_name.length+1;
                c_end=document.cookie.indexOf(";",c_start);
                if (c_end==-1){ 
                    c_end=document.cookie.length;
                }
                return unescape(document.cookie.substring(c_start,c_end));
            }
        }

        return "";
    },

    talkPanelScrollBottom() {
      let el = document.getElementById("dialogue_box");
      console.log(el);
      el.scrollTop = el.scrollHeight;
    },
    openmessage(){
      console.log(this.servie);
      if(this.servie == false){
        this.servie = true;
      }else{
        this.servie = false;
      }
      
      setTimeout(() => {
           this.talkPanelScrollBottom();
      }, 500);
     

    },
    //发送图片
    sendImg(e) {
      if (e) {
        api
          .sendMessage({
            content: this.sendImgUrl,
            conversationId: this.conversationData.conversationId,
            fromId: this.fromId,
            messageType: "image",
            shopId: this.shopId,
            toId: this.toId,
            toShopId: this.toShopId,
          })
          .then((res) => {
            if (res.code == "ok") {
              this.sendImgUrl = "";
              this.dialogVisible = false;
              this.conversation(this.conversationData);
            } else {
              this.$message.error(this.$t("chat.Failepicture"));
            }
          });
      } else {
        this.$message.error(this.$t("chat.Cancelledsend"));
        this.dialogVisible = false;
      }
    },
    uploadFile_(e) {
      console.log(e);
      this.uploadFile(e.file);
    },

    uploadFile(file) {
      let formdata = new FormData();
      formdata.append("photo", file);
      formdata.append("shopId", this.shopId);
      const h = this.$createElement;
      axios
        .post("https://erp.shopsbu.com/cus/message/upload", formdata, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.code == "ok") {
           
            this.sendImgUrl = res.data.photoUrl.url;
            this.dialogVisible = true;
          } else {
            this.$message.error(this.$t("chat.Failepicture"));
          }
        });
    },
    toGoodsDetailPage(shopid, itemid,country) {
      console.log(country)
      const params={
        PHP:'https://shopee.ph/~-i.',
        THB:'https://shopee.co.th/~-i.',
        MYR:'https://shopee.com.my/~-i.'
      }
      let newUrl =params[country] + shopid + '.' + itemid
      window.open(newUrl)
    },

    getScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > 102){
        this.titleDesc=true
      }else{
         this.titleDesc=false
      }
      
    },



    remote(item){
    
    console.log(item)
    api
    .getStoreItemByGroupId({groupId:item.groupId})
    .then(res => {
    if(res.code === 200 ){
      console.log('storeitem',res.data)
        this.storeItem=res.data
        this.mainImg.image=item.image
        this.mainImg.name=item.groupName
        this.mainImg.url='https://shopee.ph/~-i.' + this.storeItem.categoryData.shopId + '.' + this.storeItem.categoryData.itemId
        let falg=false
        for(let key in res.data.categoryData){
          console.log(res.data.categoryData[key])
          if(!res.data.categoryData[key]){
            falg=true
          }
        }
        console.log(falg)
        if(falg){
          this.$dialog.alert({
            message: this.$t('other.a1743'),
            title:this.$t("other.a142")
            });

        }

        if(!falg){
          let str='catid='+this.storeItem.categoryData.catId+'&itemid='+this.storeItem.categoryData.itemId+'&shopid='+this.storeItem.categoryData.shopId
          let url=utils.getSimilaryData(this.storeItem.country.toLowerCase(),str)
          this.conturyCode=this.storeItem.country.toLowerCase()

          newOrders
          .proxyHttps({
              type:0,
              url:url,
              headerMap:null,
          })
          .then(res => {
           this.tableList=res.data.sections.similar_product.data.item
          let temp=null
          this.tableList.forEach(e => {
            let saleDays = utils.getMin(30, utils.getDayInterval(e.ctime))
            if (saleDays === 0) {
              temp = 0
            } else {
              let averagePrice = utils.calculateAveragePrice(
                e.models,
                e.currency,
                e.price_max,
                e.price_min,
              )
              temp = parseInt(
                utils.calculateTotalSales(averagePrice, e.sold) / saleDays
              )
            }
            e.surgeIndex = temp
          })
         
           this.dialogVisible=true
           console.log('11',this.tableList)
          })
        }
        
    }else{
      this.$message.warning(res.msg)
    }
    })
   

  },


    generatelink(){

      newOrders
        .getUserInviteCode({userId:this.userId})
        .then(res => {
        if(res.code === 200 ){
        
         this.h5Url='https://' + location.host + '/mh5/distributionStore?invitationCode='+res.data.invitationCode
        //  this.dialogVisible_h5=true
      
        window.open(this.h5Url)
        }else{
        this.$message.warning(res.msg)
        }
        })
      
     
    },

    //控制每页显示订单条数
			handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.dataParams.offset =Number( `${val}`)
        this.handleCurrentChange()
      },
      //显示当前第几页
      handleCurrentChange(val) {
        let currentPage = (parseInt(`${val}`) - 1) * this.dataParams.offset
        this.dataParams.page=currentPage ? currentPage : 0
        this.getCommunityData(this.dataParams)
        
      },

    viewItem(item){
      console.log(item)
      this.$router.push({
        path:'/Detail',
        query:{
          productId:item.productId,
          groupId:item.groupId,
          userId:this.$route.query.userId
        }
      })
    },

    // 计算月销售额
    getMonthTotalSales(models, currency, price_max, price_min, sold) {

      let ttp=null
      if (models && models.length) {
        // 计算平均值
        let result = utils.calculateAverage(models, 'price')
        ttp =utils.parseRate(result, currency)
        
      }else{
        ttp= utils.parseRate((price_max + price_min) / 2, currency)
      }
      
      return parseInt(ttp * sold)
    },
     getLatestRMBPrice(price, currency) {
      return utils.parseRate(price, currency).toFixed(1)
    },
  //获取日期间隔
  getDayNum(time) {
    let added = new Date(time * 1000)
    let today = new Date()
    let dayNum = parseInt(Math.abs(today - added) / 1000 / 60 / 60 / 24)
    return dayNum
      
  },
  // 计算最低售价 原始价格
  getLatestOriginPrice(price) {
      return (price / 100000).toFixed(1)
    },
  //转化指数
  getConversionRate(sold, count) {
    if (count === 0) {
      return '0.00%'
    }
    return ((sold / count) * 100).toFixed(2) + '%'
  },

    handleCategory(value){
      this.dataParams.categoryIds=[]
      this.dataParams.country=JSON.parse(JSON.stringify(value[0]))
      this.allCateGoryList.forEach(p => {
        if(p.categoryId == 100001){
          console.log('100001',p)
        }
      })

      let obj =this.allCateGoryList.find(item => item.categoryId === value[value.length-1] && item.country === value[0])
        if(obj && obj.hasChildren){
          obj.childrens.forEach(p => {//一级
            this.dataParams.categoryIds.push(p.categoryId)
            if(p.hasChildren){
              p.childrens.forEach(i => {//二级
                this.dataParams.categoryIds.push(i.categoryId)
                if(i.hasChildren){//三级
                  i.childrens.forEach(m => {
                    this.dataParams.categoryIds.push(m.categoryId)
                    if(m.hasChildren){//四级
                      m.childrens.forEach(b => {
                        this.dataParams.categoryIds.push(b.categoryId)
                        if(b.hasChildren){
                          b.childrens.forEach(r => {
                              this.dataParams.categoryIds.push(r.categoryId)
                          })
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        }else if(!obj){
          this.dataParams.categoryIds=[]
        }else{
          this.dataParams.categoryIds.push(obj.categoryId)
        }
       
       console.log(this.dataParams)
       this.getCommunityData(this.dataParams)
     
      
 
      
      
    },

    copyStoreItem(item){
      console.log('item',item)
      item.checked=!item.checked
    },

     getImageUrlCopy(contury,image){
      return utils.getImageUrl(contury,image)
  },

    init(){
        // let userId=this.$route.query.userId
        // this.warehouseId=this.storeId
        this.dataParams.userId=this.$route.query.userId
        this.getCommunityData(this.dataParams)
   
    },

    // getCommunityDataCopy(params){
    //   api
    //   .getPublicStoreItem(params)
    //   .then(res => {
    //     if(res.code == 200){
    //       console.log('公共分销仓的产品11',res.data)
    //       res.data.groups.forEach(p => {
    //         p.checked=false

    //       })
    //       this.originData=res.data.groups

          
    //     }else{
    //       this.$message.warning(res.msg)
    //     }
    //   })
    // },

     chooseCountry(id){
      this.descActive=id;
      this.dataParams.country=this.descActive =='All' ? null : id
      this.getCommunityData(this.dataParams)
    },

    getCommunityData(params){
      api
      .getPublicStoreItem(params)
      .then(res => {
        if(res.code == 200){
          console.log('公共分销仓的产品',res.data)
          let groupids=[]
          res.data.groups.forEach(p => {
            p.checked=false
            groupids.push(p.groupId)

          })
        

          console.log('aaaaaaaaaaaaa')
          this.overDataList=res.data.groups
          this.count=res.data.count

          let obj=JSON.parse(JSON.stringify(params))

          obj.offset=res.data.count+1

          this.getCommunityDataCopy(obj)
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    foucuItem(){
      this.cageGoryList=this.cageGoryList
      this.shwoCategory=true
    },

    updataName(name){
      console.log('name',name)
      this.name=name
    },

    getCommunityData(params){
      api
      .getDXSProduct(params)
      .then(res => {
        if(res.code == 200){
          console.log('公共分销仓的产品',res.data)
          res.data.products.forEach(p => {
            p.checked=false
           
           
          })
          this.overDataList=res.data.products
          this.count=res.data.count
        }else{
          this.$message.warning(res.msg)
        }
      })
    },

    getCategoryByDistribute(){
      api
      .getPublicStoreItem(this.dataParams)
      .then(res => {
        if(res.code == 200){
          console.log('分销仓的产品分类',res.data)
          res.data.groups.forEach(p => {
            p.label=utils.conutryConversion(p.country)
            p.value=p.country
            if(p.data.length){
              this.allCateGoryList.push(p)
              p.hasChildren=true
              p.children=[]
              p.data.forEach(i => {
                i.country=p.country
                this.allCateGoryList.push(i)
                i.label=i.categoryName,
                i.value=i.categoryId
                if(i.hasChildren) {
                  i.children=i.childrens
                  i.children.forEach(j => {
                    j.country=p.country
                    this.allCateGoryList.push(j)
                    j.value=j.categoryId,
                    j.label=j.categoryName
                    if(j.hasChildren) {
                      j.children=j.childrens
                      j.children.forEach(k => {
                        k.country=p.country
                        this.allCateGoryList.push(k)
                        k.value=k.categoryId,
                        k.label=k.categoryName
                        
                      })
                    }
                  })
                }
                p.children.push(i)
              })
            }
          })

          console.log('147147',res.data)
           res.data.unshift({
             label:this.$t('other.a3199'),
             value:'',
             hasChildren:false,
             children:[]
           })

           console.log('allCateGoryList',this.allCateGoryList)
          this.cageGoryList=res.data
        }else{
          this.$message.warning(res.msg)
        }
      })
    },

    getStoreItemAndGroup(){
      console.log(this.cusCode)
      this.getCommunityData(this.dataParams)
    },
    getCountry(code){
      return utils.conutryConversion(code)
    },
    goto(){
      this.storerageData(this.targetList)
      this.$router.push({
        path:'/distributionOrder'
      })
    },
    showStoreName(id){
      return utils.showStoreName(id)
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";


@media (max-width: 575px)  {
  .iddstation{

    .query_list{
      display: none;
    }

    .delivercy{
      display: none;
    }

    .product{
      text-align: center;
      margin-top: 0.5rem;
      font-size: 0.8rem;
      border-top: 8px solid #eee;
    }

    .fiexed{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      text-align: center;
      background: #fff;
      margin: 0;
      border-top:none;

    }

    .mobile{
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.5rem;



      .left{
        display: flex;
        align-items: center;

        .mobile_img{
          background-image: url('../../../assets/img/touxiang.png') ;
          background-size: 100%;
          background-repeat: no-repeat;
          width: 3rem;
          height: 3rem;
          margin: 5px 10px;
          
        }

        .shopname{
          font-weight: bold;
          font-size: 18px;
        }

        
      }

      .right{
        margin-right:1rem ;
        border: 1px solid red;
        border-radius: 2px;
        color: red;
        padding:0px 10px;

        .icon-kehufuwu{
          
          font-size:1rem
        }
      }


      

    }

    .header_top{
      display: none;
    }
    


    .overseaProduct_list{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      background-color: #eee;
      
    }

    

    .overseaProduct_item{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-items: center;
      background-color: #fff;
      width: 48%;
      box-sizing: border-box;
      padding: 2px;
      margin: 2px;
      


       .item_desc{
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          padding:5px 0
        }

        .kvnk ,.update_overseaProduct{
          display: none;
        }

        .item_desc_parentsku{
          color: #F56C6C;
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 10px;
          white-space: nowrap;
          padding:2px 0
        }


      .title_overseaProduct{
        width: 6rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 10px;
        
        

      }

      .pic_box{
        width: 6rem;
        height: 6rem;
        overflow: hidden;

        img{
          width: 100%;
        }
      }
    }

  }
}



@media (min-width: 1200px)  {


  
  .iddstation { 
    
   
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  
    

  /deep/ .el-input__inner{
    height: 45px;
    width: 800px;
    font-size: 18px;
  }

  /deep/ .el-icon-download::before{
    padding-right:8px;
  }

/deep/ .el-dialog__body{
  margin-top: 10px;
  padding:0 10px
}

/deep/ .el-dialog__title{
  display: inline-block;
  width: 250px;
  height: 47px;
  background-image: url('../../../assets/img/pic/shopeelogo.png');
  background-repeat: no-repeat;
  background-size: 60%;
}
/deep/ .el-icon-close{
  color: #eee;
  font-size: 25px;
}

/deep/ .el-dialog__header{
  padding: 20px 20px 10px;
  background: linear-gradient( 
  -180deg
  ,#f53d2d,#f63);
  
}

/deep/ .el-dialog__close{
  display: none;
}
// .service-body{
// 		width: 120px;
// 		height: 80px;
// 		background: #409eff;
// 		display: flex;
// 		color: #fff;
// 		align-items: center;
// 		justify-content: center;
// 		flex-direction: column;
// 		position: fixed;
// 		top: 70%;
// 		right: 0%;
// 		z-index: 9999;
// 		cursor: pointer;
// 		border-radius: 20px;

// 	}
// 	.service-body:hover{
// 		background: #0066ff;
// 	}
// 	.service-mess{
// 		width: 450px;
// 		height: 500px;
// 		display: flex;
// 		background: #eee;
// 		align-items: flex-start;
// 		justify-content: flex-start;
// 		flex-direction: column;
// 		position: fixed;
// 		top: 30%;
// 		right: 10%;
// 		border-radius: 10px;
//     z-index: 9999;
//     -webkit-box-shadow: #666 0px 0px 10px;
//    -moz-box-shadow: #666 0px 0px 10px;
//    box-shadow: #666 0px 0px 10px;
   
// 	}
	.talk-list{
    flex: 1;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		
		
  }
  .customer_chat_recode{
		width: 450px;
		height: 300px;
    border-bottom: 1px solid #EEEEEE;
    overflow-y: auto;
    overflow-x: hidden;
  } 
  .chat_recode_items{
    display: flex;
			align-items: center;
			margin:10px 10px;
      font-size: 14px;
      
  }
  .reverse_row{
		flex-direction: row-reverse;
	}
  .chat_desc{
		max-width: 300px;
		word-wrap: break-word;
		background-color: #fff;
		padding: 8px 20px;
		margin:0 0 5px 0px;
		
		border-radius: 10px 20px 20px 0;
		color: #000;
  }
  .reverse_desc_row{
		 max-width: 300px;
		word-wrap: break-word;
		background-color: #409eff;
		padding: 8px 20px;
		margin:0 10px 5px 0px;
		color: #fff;
		border-radius: 20px 10px 0px 20px !important;
  }
  .upload-demo{
    margin-left: 20px;
  }


 

  .pic_box{
		width: 40px;
		height: 40px;
		border-radius: 50%;
		overflow: hidden;
	}
  .ser-three{
    	width: 450px;
    height: 150px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
		position: relative;
  }
  .sendcc{
    position: absolute;
    top: 110px;
    right: 10px;
  }
  .ser-th-one{
    width: 450px;
    height: 40px;
    display: flex;
    align-items:center;
    justify-content: flex-start;
    background: #fff;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
	.ser-one-boy{
		width: 40px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
		margin-right: 10px;
	}
	.ser-tit-one{
		width: 50px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		/* background: chocolate; */
	}
	.ser-one-boy:hover{
		background: #0066ff;
	}
	.ser-one{
		width: 450px;
		height: 50px;
		display: flex;
		background: #409eff;
		align-items: center;
		justify-content:space-between;
		border-radius: 10px;

	}
	.ser-one-title{
		width: 300px;
		height: 60px;
		display: flex;
		margin-left: 10px;
		align-items: center;
		justify-content: flex-start;
		border-radius: 10px;
	}

.kknln{
  color: #fff;
  cursor: pointer;
}
/deep/ .el-textarea__inner {
    border: 0;
    resize: none;
    background: #fff;
  }

.textDesc{
  position: absolute;
    top: 23px;
    width: 100%;
    margin: auto;
    text-align: center;
    
    color: #fff;
    font-size: 24px;
}
  

  .Pager{
    position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	
  }

  .overseaProduct_list{
        display: flex;
        width: 1200px;
        flex-wrap: wrap;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        margin-top: 23px;
       
       

        .overseaProduct_item{
            box-sizing: border-box;
            margin: 8px 5px;
            background-color: #fff;
            border-radius: 5px;
             border: 1px solid #fff;

        }

        .overseaProduct_item_active{
          border: 1px solid #F56C6C;
         
        }

        .kvnk{

          text-align: left;
          margin: 7px 0;

          .kvjhf{
            color: #409eff;
            font-size: 14px;
            padding-left:5px;
            cursor: pointer;
          }
        }

        .update_overseaProduct{
          
          text-align: right;
          margin: 7px 0;

          .kvjhf{
            color: #409eff;
            font-size: 14px;
            padding-left:5px;
            cursor: pointer;
          }

          .btn{
            background-color: rgb(42, 165, 21);
            border-radius: 3px;
            padding:4px 5px;
            color: #eee;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
            display: inline-block;
            min-width: 60px;
            text-align: center;
            
          }

          .btn_reverse{
             background-color: #F56C6C;
              border-radius: 3px;
              padding:4px 5px;
              color: #eee;
              font-size: 12px;
              font-weight: bold;
              cursor: pointer;
          }
        }
        
     


        .pic_box{
            width: 159px;
            height: 159px;
            overflow: hidden;
            border-radius: 5px;
            cursor: pointer;
        }
        .title_overseaProduct{
            width:148px;
            height: 1.7rem;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 2px;
            font-size: 12px;
            white-space: nowrap;

            
            
        }

        .item_desc{
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          padding:5px 0
        }

        .item_desc_parentsku{
          color: #F56C6C;
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          padding:5px 0;
          
          
        }

        
    }

  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }


  .query_list {
      padding: 10px 0 15px 0;
      @include flex-center();
     

      .poo_active{
        background-color: #409eff;
        color: #fff;
      }

      .poo{
        display: flex;
        justify-content: flex-start;
        min-width: 50px;
        min-height: 50px;
        line-height: 30px;
        align-items: center;
        box-shadow: 0 1px 6px 0 #eee;
        border-radius: 8px;
        margin-right: 10px;
        box-sizing: border-box;
        padding: 0 5px;
        cursor: pointer;
        

        .test{
          display: inline-block;
          flex: 1;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          margin: 0 10px;
        }
      }
    }


  




  .delivercy{
        width: 1200px;
    position: absolute;
    top: 105px;
    left: 0;
    right: 0;
    margin: auto;
    font-size: 22px;

  }

  .icon-gouwuche{
    font-size: 30px;
    color: #f53d2d;
  }

  .gowuche{
    margin-left: 10px;
    font-weight: bold;
  }

  .header_top {
    position: fixed;
      width: 100%;
      height: 100px;
      top: 0;
      background-color: #409eff;
      z-index: 89;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .cirlce{
            position: absolute;
            width: 25px;
            height: 25px;
            line-height: 25px;
            border-radius: 50%;
            background-color: red;
            top: -20px;
            left: 17px;
            text-align: center;
      }

    .query-list-tcp {
      width: 1200px;
        position: absolute;
        margin: auto;
        
        left: 0;
        right: 0;
        color: #fff;
        z-index: 90;
        display: flex;
        align-items: center;
        justify-content: space-around;


        .btn{
          position: absolute;
            right: 2px;
            top: 2.5px;
            
        }

        
        

        .oknv{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

     

      .logo{
        background-image: url('../../../assets/img/h5_login.png');
        background-size: 100%;
        background-repeat: no-repeat;
        width: 60px;
        height: 60px;

      }
    }
    

    .cateGory_wrapper{
      margin: 0 20px;
      position: relative;

      .cateGory_box{
        position: absolute;
       
        left: -250px;
      }
    }
  }

  .goodsArea {
    margin-top: 237px;
    margin-bottom: 120px;
  }

  .list-item {
    padding: 0 20px 0 0;
    margin-bottom: 10px;
    background-color: #fff;
    box-sizing: border-box;
    margin: 5px 10px;
    padding: 10px;

    .childrenItem {
      padding: 10px 0 5px 25px;
      border-bottom: 1px solid #eee;

      .goods-title-desc-wrapper {
        @include flex-between();

        .check_And_Img {
          display: flex;
        }
      }
    }

    .outPsku {
      @include flex-between();
      align-items: center;

      .outPsku_left {
        display: flex;
        align-items: center;

        .el-input {
          width: 300px;
        }

        .el-icon-edit {
          margin-left: 15px;
          cursor: pointer;
          color: #409eff;
          font-size: 18px;
        }
      }

      .outPsku_right {
        display: flex;
        align-items: center;
      }
    }

    .btn-item-desc {
      padding: 0 0 8px 0;
    }

    .outDesc {
      @include flex-between();

      .goods-pic {
        width: 80px;
        height: 80px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}



}





</style>